import React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className="header">
            <div className="title">
                <h2>BD Squad</h2>
            </div>
            
            
        </div>
    );
};

export default Header;